/* ===========================
   Les 9 Parfums — Theme JS
   Version 2.1 (production)
   =========================== */

// ===========================
// Shopify Config (injecté par theme.liquid)
// ===========================
function getLes9Config() {
  return window.LES9_CONFIG || {
    whatsapp_number: '212600000000',
    whatsapp_message: 'Bonjour, je suis intéressé(e) par vos parfums',
    shipping_cost: 35,
    free_shipping_threshold: 199
  };
}

// ===========================
// DOM Ready
// ===========================
document.addEventListener('DOMContentLoaded', function() {
  initHeaderScroll();
  initMobileMenu();
  initScrollAnimations();
  initSmoothScroll();
  initCartCount();
});

// ===========================
// Header Scroll Effect
// ===========================
function initHeaderScroll() {
  var header = document.getElementById('header');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }, { passive: true });
}

// ===========================
// Mobile Menu
// ===========================
function initMobileMenu() {
  var btn     = document.getElementById('mobile-menu-btn');
  var overlay = document.getElementById('mobile-nav-overlay');
  var closeBtn = document.getElementById('mobile-nav-close');
  if (!btn || !overlay) return;

  function openMenu() {
    overlay.style.display = 'block';
    requestAnimationFrame(function() { overlay.classList.add('active'); });
    overlay.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    overlay.classList.remove('active');
    overlay.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function() {
      if (!overlay.classList.contains('active')) overlay.style.display = '';
    }, 350);
  }

  btn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeMenu();
  });
  overlay.querySelectorAll('.mobile-nav__link').forEach(function(link) {
    link.addEventListener('click', closeMenu);
  });

  // Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('active')) closeMenu();
  });
}

// ===========================
// Scroll Animations (IntersectionObserver)
// ===========================
function initScrollAnimations() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.feature-card, .review-card, .pack-offer__inner, .section-header')
      .forEach(function(el) { el.classList.add('revealed'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.feature-card, .review-card, .pack-offer__inner, .section-header')
    .forEach(function(el) {
      el.classList.add('reveal');
      observer.observe(el);
    });
}

// ===========================
// Smooth Scroll (for any remaining # anchors)
// ===========================
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

// ===========================
// Cart Count — keep header badge in sync after AJAX
// ===========================
function initCartCount() {
  // Listen for custom cart:updated events that sections can dispatch
  document.addEventListener('cart:updated', function(e) {
    var count = (e.detail && typeof e.detail.item_count === 'number') ? e.detail.item_count : null;
    if (count === null) {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(updateCounters);
    } else {
      updateCounters({ item_count: count });
    }
  });

  function updateCounters(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }
}

// ===========================
// CSS animations injected dynamically
// ===========================
(function() {
  var s = document.createElement('style');
  s.textContent =
    '@keyframes cardFadeIn { from { opacity: 0; transform: translateY(20px) scale(0.97); } to { opacity: 1; transform: translateY(0) scale(1); } }' +
    '.animate-card { animation: cardFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; opacity: 0; }' +
    '@keyframes shake { 0%,100% { transform: translateX(0); } 10%,30%,50%,70%,90% { transform: translateX(-5px); } 20%,40%,60%,80% { transform: translateX(5px); } }';
  document.head.appendChild(s);
})();
